import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const zoomBlurOut = keyframes`
  0%   { transform: scale(1);   opacity: 1; filter: blur(0); }
  100% { transform: scale(1.4); opacity: 0; filter: blur(12px); }
`

export const CouponStepWrapper = styled.div<{ isDrawing: boolean }>`
  width: 100%;
  height: 100%;
  ${({ isDrawing }) =>
    isDrawing &&
    css`
      animation: ${zoomBlurOut} 0.45s ease-in forwards;
    `}
`

export const FULL_SIZE_STYLE = { width: '100%', height: '100%' } as const

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100dvh;
`
